<template>
    <div class="pb-2">
        <div class="row">
            <div class="col-12">
                <vue-form-generator
                    ref="teamMemberForm"
                    :schema="schemaStatus"
                    :model="modelform"
                    :options="formOptions"
                ></vue-form-generator>
            </div>
        </div>
        <div class="row">
            <div class="col-12">   
            <button v-if="!editing" class="
                            btn
                            btn-primary
                            mr-3
                            btn-sm
                            float-right
                            cursor-pointer
                            font-weight-bolder
                            btn-primary" type="button" @click="newMember">
               <i class="icon-plus"></i> {{ $t("lang.search.add") }}
            </button>
            <button v-else class="btn
                            btn-primary
                            btn-sm
                            col-md-2
                            mr-3
                            mb-5
                            cursor-pointer
                            btn-success" type="button" @click="newMember">
                {{ $t("lang.button.save") }}
            </button>
            </div>
        </div>
        
        <div class="row justify-content-center mt-4 text-center" v-if="alertMessage">
            <AlertError :msgError="alertMessage" />
        </div>
    </div>

</template>

<script>
import { mapActions, mapState } from "vuex";
import VueFormGenerator from "vue-form-generator";
import { usersService } from "@/_services";
import AlertError from "@/components/AlertError.vue";

export default {
    data() {
        return {
            target: {
                
            },
            editing: false,
            editingEmail: "",
            alertMessage: "",
			modelform:{
                index: 0,
                first_name: "",
                last_name: "",
                email: "",
                linkedinurl: "",
            },
			schemaStatus: {
        	   fields: [
		           {
		            type: "input",
		            inputType: "text",
		            model: "first_name",
                    placeholder: "ex : Michael",
		            featured: true,
		            required: true,
                    label: this.$t("lang.label.firstname"),
		            validator: VueFormGenerator.validators.string.locale({
		              fieldIsRequired: this.$t("lang.label.required"),
		            }),
                    styleClasses: "col-md-2"
		           },
		           {
		            type: "input",
		            inputType: "text",
		            model: "last_name",
                    placeholder: "ex : Platini",
		            featured: true,
		            required: true,
                    label: this.$t("lang.label.lastname"),
		            validator: VueFormGenerator.validators.string.locale({
		              fieldIsRequired: this.$t("lang.label.required"),
		            }),
                    styleClasses: "col-md-3"
		           },
                   {
                    type: "input",
                    inputType: "email",
                    label: "Email",
                    model: "email",
                    id:"email",
		            featured: true,
		            required: true,
                    placeholder: "ex : michael@gmail.com",
		            validator: VueFormGenerator.validators.email.locale({
		              fieldIsRequired: this.$t("lang.label.required"),
		              invalidEmail: this.$t("lang.validation.email"),
		            }),
                    styleClasses: "col-md-4"
                   },
                   {
                    type: "input",
                    inputType: "url",
                    label: "Linkedin",
                    model: "linkedinurl",
                    id:"linkedinurl",
		            featured: true,
		            required: true,
                    placeholder: "ex : https://www.linkedin.com/in/michael-platini",
                    styleClasses: "col-md-3"
                   },
		        ],
		    },
		    formOptions: {
		        validateAfterLoad: false,
		        validateAfterChanged: true,
		    },
			hourly:false,
		}
    },

    computed: {
        ...mapState({
            teamMembers: state => state.onboarding.step3.teamMembers
        })
    },

    components: {
        "vue-form-generator": VueFormGenerator.component,
        AlertError
    },

    props: {
        member: Object,
        editingIndex: Number,
        add: {
            type: Boolean,
            default:false,
        }
    },

    watch: {
        member: function (member) {
            this.modelform.first_name = member.first_name;
            this.modelform.last_name = member.last_name;
            this.modelform.email = member.email;
            this.modelform.linkedinurl = member.linkedinurl;
            this.modelform.index = this.editingIndex;
            this.editing = true;
            this.editingEmail = member.email;
        }
    },

    methods: {
        ...mapActions("onboarding", {
            addTeamMember: "addTeamMember"
        }),
        addMember(){
            if(this.add){
                let model = {
                    first_name : this.modelform.first_name,
                    last_name : this.modelform.last_name,
                    email:this.modelform.email,
                    phone:"",
                    linkedinurl: this.modelform.linkedinurl
                }
            }else{
                this.addTeamMember(this.modelform);
            }
            this.$emit('newForm',this.modelform);
        },

        newMember() {
            this.$refs.teamMemberForm.validate();
            if (this.$refs.teamMemberForm.errors.length > 0) {
                return;
            }
            if (this.editingEmail == this.modelform.email){
                this.addMember()
            } else if (this.mailIsUnique(this.modelform.email) || this.add){
                usersService.getCheckMail(this.modelform.email).then((res) => {
                    if (!res) {
                        this.addMember()
                    } else {
                        if (this.add)
                           this.alertMessage = this.$t("lang.label.emailalreadyexists")
                        else
                            this.showDuplicatedEmailError()
                    }
                });
            }
        },

        showDuplicatedEmailError(){
            this.$swal({
                            type: "error",
                            title: this.$t("lang.label.error"),
                            text: this.$t("lang.label.emailalreadyexists"),
                            showConfirmButton: false,
                            timer: 1900,
                        });
        },

        mailIsUnique(email){
            return this.teamMembers.every(teamMember => {
                if(teamMember.email == email){
                    this.showDuplicatedEmailError()
                    return false
                }
                return true
            });
        }
    }
}
</script>